import { type AppDownloadStore } from '@/shared/model';

export const CANVAS_WIDTH = 243;
export const CANVAS_HEIGHT = 137;

export interface PartnerLogo {
  file: string;
  name: string;
  left: number;
  top: number;
  width: number;
  height: number;
  href?: string;
}

export const PARTNER_LOGOS: PartnerLogo[] = [
  { file: 'visa.svg', name: 'Verified by VISA', left: 0, top: 0, width: 64, height: 28 },
  { file: 'master-card.svg', name: 'MasterCard SecureCode', left: 89, top: 3, width: 63, height: 22 },
  { file: 'ata.svg', name: 'Альянс туристических агентств', left: 179, top: 2, width: 64, height: 23 },
  { file: 'sberbank.svg', name: 'Сбербанк', left: 0, top: 55, width: 100, height: 19 },
  { file: 'prom.svg', name: 'Промсвязьбанк', left: 127, top: 54, width: 88, height: 21 },
  { file: 'skolkovo.svg', name: 'Сколково', left: 0, top: 99, width: 50, height: 37, href: 'https://sk.ru/' },
  { file: 'mir.svg', name: 'МИР', left: 76.5, top: 101, width: 89, height: 35 },
  { file: 'ktr.svg', name: 'Каталог турагентств России', left: 192, top: 104, width: 29, height: 28 },
];

export interface AppBadge {
  file: string;
  type: AppDownloadStore;
}

export const APP_BADGES: AppBadge[] = [
  { file: 'appstore.svg', type: 'appstore' },
  { file: 'playstore.svg', type: 'playstore' },
];

export interface SocialIcon {
  file: string;
  href: string;
}

export const SOCIAL_ICONS: SocialIcon[] = [
  { file: 'vk.svg', href: 'https://vk.ru/travelata' },
  { file: 'ok.svg', href: 'http://www.odnoklassniki.ru/group/51008627736716' },
  { file: 'telegram.svg', href: 'https://t.me/travelata' },
  { file: 'whatsapp.svg', href: 'https://vb.me/travelata' },
];
